//src/firebase/index.ts

import { initializeApp } from 'firebase/app'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { isFirebaseEmulatorMode } from '@/utils/firebaseEnvironment'
//import { getStripePayments, StripePaymentsOptions } from '@invertase/firestore-stripe-payments'

export const firebaseConfig = {
  apiKey: 'AIzaSyA8lk2-juQf44BTr_lgVDLXiG5Z-vK2J_w',
  authDomain: 'aeropro-command.firebaseapp.com',
  projectId: 'aeropro-command',
  storageBucket: 'aeropro-command.appspot.com',
  messagingSenderId: '616165011647',
  appId: '1:616165011647:web:39e53fdac16d0ad456560a'
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const auth = getAuth(app)
const fileStorage = getStorage(app, 'gs://aeropro-command.appspot.com')
const functions = getFunctions(app)
// Vite loads .env.local for production builds too. Never allow a production
// bundle to connect customers' browsers to developer-only localhost emulators.
const useFirebaseEmulators = isFirebaseEmulatorMode()

if (useFirebaseEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, '127.0.0.1', 8080)
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
  connectStorageEmulator(fileStorage, '127.0.0.1', 9199)
}
//const payments = getStripePayments(app, {
//  productsCollection: 'Stripe-Products',
//  customersCollection: 'Stripe-Customers' //Stripe-Configurations
//} as StripePaymentsOptions)

//export { db, auth, fileStorage, functions, payments }
export { db, auth, fileStorage, functions }
